module.exports = __webpack_public_path__ + "img/jia.7359d047.png";